// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Golos+Text:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Jost:ital,wght@0,100..900;1,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&family=Unna:ital,wght@0,400;0,700;1,400;1,700&family=Yatra+One&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
  font-family: 'Golos Text';
  background-color: #fdfdfd;
  overflow: auto;
}

body::-webkit-scrollbar {
  display: none;
}
p {
  margin: 0px;
}
ul,
ol {
  padding: 0px;
  list-style: none;
  margin: 0px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
}
a {
  text-decoration: none;
  display: inline-block;
}
span,
strong {
  display: inline-block;
}

.rdp {
  --rdp-cell-size: 36px;
  --rdp-accent-color: #0077ff;
  --rdp-background-color: #e7f2ff;
  margin: 0;
}

.rdp-day {
  border-radius: 6px;
  font-size: 13px;
}

.rdp-day_selected {
  background-color: var(--rdp-accent-color);
  color: white;
}

.rdp-day_selected:hover {
  background-color: var(--rdp-accent-color);
}

.rdp-day_today:not(.rdp-day_selected) {
  font-weight: bold;
  color: var(--rdp-accent-color);
}

.rdp-day_disabled {
  opacity: 0.25;
}

.rdp-caption {
  margin-bottom: 8px;
}

.rdp-caption_label {
  font-size: 14px;
  font-weight: 500;
}

.rdp-nav_button {
  width: 24px;
  height: 24px;
  border-radius: 6px;
}

.rdp-nav_button:hover {
  background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Golos+Text:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Jost:ital,wght@0,100..900;1,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&family=Unna:ital,wght@0,400;0,700;1,400;1,700&family=Yatra+One&display=swap');\nbody {\n  margin: 0px;\n  font-family: 'Golos Text';\n  background-color: #fdfdfd;\n  overflow: auto;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\np {\n  margin: 0px;\n}\nul,\nol {\n  padding: 0px;\n  list-style: none;\n  margin: 0px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0px;\n}\na {\n  text-decoration: none;\n  display: inline-block;\n}\nspan,\nstrong {\n  display: inline-block;\n}\n\n.rdp {\n  --rdp-cell-size: 36px;\n  --rdp-accent-color: #0077ff;\n  --rdp-background-color: #e7f2ff;\n  margin: 0;\n}\n\n.rdp-day {\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.rdp-day_selected {\n  background-color: var(--rdp-accent-color);\n  color: white;\n}\n\n.rdp-day_selected:hover {\n  background-color: var(--rdp-accent-color);\n}\n\n.rdp-day_today:not(.rdp-day_selected) {\n  font-weight: bold;\n  color: var(--rdp-accent-color);\n}\n\n.rdp-day_disabled {\n  opacity: 0.25;\n}\n\n.rdp-caption {\n  margin-bottom: 8px;\n}\n\n.rdp-caption_label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rdp-nav_button {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n}\n\n.rdp-nav_button:hover {\n  background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
